// Gesture Handler 3.4 probes this file to see if
// AnimatedComponent.prototype._refreshComponentRef exists. Reanimated 4.7
// ships it as TypeScript and does not implement that method. Webpack does not
// transpile react-native-reanimated (doing so rewrites its ESM into bare
// require() calls the browser cannot run), so the probe is replaced with a
// class that answers no.
export default class AnimatedComponent {}
